<script>

    let { items, id = $bindable() } = $props();

</script>

<ul>
    {#each items as item}
    <li>
        <button onclick={() => id = item.id} aria-pressed={item.id === id}>
            {item.name}
        </button>
    </li>
    {/each}
</ul>

<style>

    ul {
        display: flex;
        list-style: none;
        padding: 0;
        margin: 0 0 3em 0;
        gap: 0.7em;

        flex-wrap: wrap;

        background: var(--box-color);
        border-radius: 2.3em;
        padding: 1em;
    }

    li {
    }

    button {
        background: var(--background-color); 
        color: var(--text-color);
        border: none;
        border-radius: 2em;
        padding: 0.7em 1em;
        text-wrap: nowrap;
        font-size: 1.1em;

        cursor: pointer;
    }

    button[aria-pressed="true"] {
        background: var(--accent-background);
        color: var(--accent-color);
    }

</style>